import React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const HotelHome = (props: IconProps) => {
    return (
        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M7.50958 12.9885H9.73773V8.95667L6.76686 6.63525L3.79598 8.95667V12.9885H6.02414V10.3264H7.50958V12.9885ZM16.4222 14.3196H3.05327C2.85628 14.3196 2.66737 14.2495 2.52808 14.1247C2.3888 13.9999 2.31055 13.8306 2.31055 13.6541V8.65384C2.31054 8.55875 2.33327 8.46475 2.37721 8.37819C2.42116 8.29162 2.48529 8.2145 2.5653 8.15203L5.28142 6.02961V3.00539C5.28142 2.82887 5.35967 2.65959 5.49896 2.53478C5.63824 2.40996 5.82716 2.33984 6.02414 2.33984H16.4222C16.6192 2.33984 16.8081 2.40996 16.9474 2.53478C17.0867 2.65959 17.1649 2.82887 17.1649 3.00539V13.6541C17.1649 13.8306 17.0867 13.9999 16.9474 14.1247C16.8081 14.2495 16.6192 14.3196 16.4222 14.3196ZM12.7086 7.66418V8.99527H14.194V7.66418H12.7086ZM12.7086 10.3264V11.6574H14.194V10.3264H12.7086ZM12.7086 5.00201V6.3331H14.194V5.00201H12.7086ZM9.73773 5.00201V6.3331H11.2232V5.00201H9.73773Z"
                fill={props.color || "#000"}
            />
        </svg>
    )
}

export default HotelHome
